import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/content";

export default function WhatsAppFab() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
            "Hello Parin, I found you via parinmajithia.com — I'd like to connect about"
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-fab"
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 right-6 z-40 group"
          aria-label="Chat on WhatsApp"
        >
          <span className="absolute inset-0 rounded-full bg-copper/40 animate-ping [animation-duration:2.5s]" />
          <span className="relative flex items-center gap-3 rounded-full bg-copper text-ink-950 hover:bg-copper-hover pl-4 pr-5 py-3.5 shadow-2xl shadow-copper/20 transition-colors">
            <MessageCircle size={18} strokeWidth={2.25} />
            <span className="font-mono-caps text-[10px] hidden sm:inline">WhatsApp</span>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
